(() => {
  const pad = (value) => String(Math.max(0, value)).padStart(2, '0');

  const setupCountdown = (root) => {
    if (!root || root.dataset.coastaCountdownReady === 'true') return;
    const endRaw = root.dataset.end;
    const end = Date.parse(endRaw || '');
    if (!Number.isFinite(end)) {
      root.hidden = true;
      return;
    }
    root.dataset.coastaCountdownReady = 'true';
    const days = root.querySelector('[data-days]');
    const hours = root.querySelector('[data-hours]');
    const minutes = root.querySelector('[data-minutes]');
    const seconds = root.querySelector('[data-seconds]');

    const update = () => {
      const remaining = Math.max(0, end - Date.now());
      const totalSeconds = Math.floor(remaining / 1000);
      const d = Math.floor(totalSeconds / 86400);
      const h = Math.floor((totalSeconds % 86400) / 3600);
      const m = Math.floor((totalSeconds % 3600) / 60);
      const s = totalSeconds % 60;
      if (days) days.textContent = pad(d);
      if (hours) hours.textContent = pad(h);
      if (minutes) minutes.textContent = pad(m);
      if (seconds) seconds.textContent = pad(s);
      if (remaining <= 0 && root._coastaTimer) {
        window.clearInterval(root._coastaTimer);
        root._coastaTimer = null;
      }
    };
    update();
    root._coastaTimer = window.setInterval(update, 1000);
  };

  const updateVariantUI = (select) => {
    if (!select) return;
    const option = select.options[select.selectedIndex];
    const formId = select.dataset.formId;
    const form = formId ? document.getElementById(formId) : null;
    const root = select.closest('[data-coasta-event-buy-root]') || select.closest('.coasta-event-spotlight');
    if (!option || !form || !root) return;

    const variantInput = form.querySelector('[data-coasta-event-variant-input]');
    if (variantInput) variantInput.value = option.value;

    const price = root.querySelector('[data-coasta-event-price]');
    const compare = root.querySelector('[data-coasta-event-compare]');
    if (price && option.dataset.price) price.textContent = option.dataset.price;
    if (compare) {
      if (option.dataset.compare) {
        compare.textContent = option.dataset.compare;
        compare.hidden = false;
      } else {
        compare.textContent = '';
        compare.hidden = true;
      }
    }

    const image = root.querySelector('.coasta-event-product__media img, .coasta-event-spotlight__media img, .coasta-event-accessory__media img');
    if (image && option.dataset.image) {
      image.src = option.dataset.image;
      image.removeAttribute('srcset');
    }

    const button = form.querySelector('[type="submit"]');
    if (button) {
      const available = option.dataset.available === 'true';
      button.disabled = !available;
      button.removeAttribute('aria-disabled');
      const text = button.querySelector('.btn-text > span') || button.querySelector('.btn-text');
      if (text) {
        const compact = button.classList.contains('coasta-event-accessory__add');
        text.textContent = available ? (compact ? 'ADD' : 'ADD TO CART') : 'SOLD OUT';
      }
    }

    root.querySelectorAll('[data-coasta-event-variant-chip]').forEach((chip) => {
      const active = String(chip.dataset.variantId) === String(option.value);
      chip.classList.toggle('is-active', active);
      chip.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  };

  const setupVariantSelect = (select) => {
    if (!select || select.dataset.coastaVariantReady === 'true') return;
    select.dataset.coastaVariantReady = 'true';
    select.addEventListener('change', () => updateVariantUI(select));
    updateVariantUI(select);
  };

  const setupVariantChip = (chip) => {
    if (!chip || chip.dataset.coastaChipReady === 'true') return;
    chip.dataset.coastaChipReady = 'true';
    chip.addEventListener('click', () => {
      if (chip.disabled) return;
      const select = document.getElementById(chip.dataset.selectId || '');
      if (!select) return;
      select.value = chip.dataset.variantId || '';
      select.dispatchEvent(new Event('change', { bubbles: true }));
    });
  };

  const setupProductFilters = (root) => {
    if (!root || root.dataset.coastaFiltersReady === 'true') return;
    root.dataset.coastaFiltersReady = 'true';
    const buttons = [...root.querySelectorAll('[data-coasta-event-filter]')];
    const section = root.closest('.coasta-event-products');
    const cards = section ? [...section.querySelectorAll('[data-coasta-event-product-card]')] : [];
    if (!buttons.length || !cards.length) return;

    const applyFilter = (filter) => {
      cards.forEach((card) => {
        card.hidden = filter !== 'all' && card.dataset.category !== filter;
      });
      buttons.forEach((button) => {
        const active = button.dataset.coastaEventFilter === filter;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', active ? 'true' : 'false');
        button.tabIndex = active ? 0 : -1;
      });
    };

    buttons.forEach((button) => {
      button.addEventListener('click', () => applyFilter(button.dataset.coastaEventFilter || 'all'));
    });
    applyFilter('all');
  };



  const setupChristmasSharedScene = (scope = document) => {
    const queryRoot = scope && scope.querySelector ? scope : document;
    let start = queryRoot.querySelector('[data-coasta-christmas-scene-start]');
    let end = queryRoot.querySelector('[data-coasta-christmas-scene-end]');

    if ((!start || !end) && scope !== document) {
      start = document.querySelector('[data-coasta-christmas-scene-start]');
      end = document.querySelector('[data-coasta-christmas-scene-end]');
    }
    if (!start || !end) return;

    const update = () => {
      const startRect = start.getBoundingClientRect();
      const endRect = end.getBoundingClientRect();
      const total = Math.max(1, endRect.bottom - startRect.top + 120);
      start.style.setProperty('--coasta-christmas-shared-height', `${Math.ceil(total)}px`);
    };

    if (start._coastaChristmasResizeObserver) {
      start._coastaChristmasResizeObserver.disconnect();
    }
    const observer = 'ResizeObserver' in window ? new ResizeObserver(update) : null;
    if (observer) {
      observer.observe(start);
      observer.observe(end);
      start._coastaChristmasResizeObserver = observer;
    }

    if (!start.dataset.coastaChristmasSceneReady) {
      start.dataset.coastaChristmasSceneReady = 'true';
      window.addEventListener('resize', update, { passive: true });
      window.addEventListener('load', update, { once: true });
    }
    requestAnimationFrame(update);
  };

  const init = (scope = document) => {
    scope.querySelectorAll('[data-coasta-event-countdown]').forEach(setupCountdown);
    scope.querySelectorAll('[data-coasta-event-variant-select]').forEach(setupVariantSelect);
    scope.querySelectorAll('[data-coasta-event-variant-chip]').forEach(setupVariantChip);
    scope.querySelectorAll('.coasta-event-product-filters').forEach(setupProductFilters);
    setupChristmasSharedScene(scope);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
